import { render, staticRenderFns } from "./PackageDependencies.vue?vue&type=template&id=cb656504&scoped=true"
import script from "./PackageDependencies.vue?vue&type=script&lang=js"
export * from "./PackageDependencies.vue?vue&type=script&lang=js"
import style0 from "./PackageDependencies.vue?vue&type=style&index=0&id=cb656504&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb656504",
  null
  
)

export default component.exports